import { ALL_SYMBOLS } from "./library/index.ts";
import type { SymbolDefinition, SymbolLibrary } from "./types.ts";

export * from "./types.ts";

export const SYMBOL_LIBRARY_VERSION = "0.1.0";

const symbolMap: ReadonlyMap<string, SymbolDefinition> = new Map(
  ALL_SYMBOLS.map((s) => [s.id, s]),
);

export const symbolLibrary: SymbolLibrary = {
  version: SYMBOL_LIBRARY_VERSION,
  symbols: symbolMap,
};

export function getSymbol(id: string): SymbolDefinition | undefined {
  return symbolMap.get(id);
}

export function listSymbols(): SymbolDefinition[] {
  return [...ALL_SYMBOLS];
}

export function searchSymbols(query: string): SymbolDefinition[] {
  const q = query.toLowerCase().trim();
  if (!q) return listSymbols();
  return ALL_SYMBOLS.filter((s) => {
    if (s.label.sv.toLowerCase().includes(q)) return true;
    if (s.label.en.toLowerCase().includes(q)) return true;
    if (s.familyKey.includes(q)) return true;
    return s.searchKeywords?.some((k) => k.toLowerCase().includes(q)) ?? false;
  });
}

export { ALL_SYMBOLS };
